import { render, staticRenderFns } from "./Body.vue?vue&type=template&id=9106ced8&"
import script from "./Body.vue?vue&type=script&lang=js&"
export * from "./Body.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Body.vue"
export default component.exports